import { render, staticRenderFns } from "./BaseSyncGrid.vue?vue&type=template&id=b04537ee&scoped=true"
import script from "./BaseSyncGrid.vue?vue&type=script&lang=ts"
export * from "./BaseSyncGrid.vue?vue&type=script&lang=ts"
import style0 from "./BaseSyncGrid.vue?vue&type=style&index=0&id=b04537ee&prod&lang=css"
import style1 from "./BaseSyncGrid.vue?vue&type=style&index=1&id=b04537ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b04537ee",
  null
  
)

export default component.exports